if (!customElements.get("variant-picker")) {
  /**
   * @class VariantPicker
   * @extends HTMLElement
   *
   * Represents a product variant picker.
   */

  class VariantPicker extends HTMLElement {
    selectors = {
      optionInput: "[name^='options']",
    };

    constructor() {
      super();

      this._onProductFormChanged = this._onProductFormChange.bind(this);
      this._onOptionChanged = this._onOptionChange.bind(this);
    }

    get currentVariant() {
      return this._currentVariant;
    }

    set currentVariant(variant) {
      this._currentVariant = variant;
    }

    get currentlySelectedOptions() {
      return this._serializeOptionValues(this.optionInputs);
    }

    async connectedCallback() {
      this.productForm = document.forms[this.getAttribute("form")];

      if (!this.productForm) {
        return;
      }

      this.product = await this._getProductJson();

      if (!Object.keys(this.product).length) {
        return;
      }

      this.productForm.addEventListener("change", this._onProductFormChanged);

      this.optionInputs = Array.from(this.querySelectorAll(this.selectors.optionInput));
      this.optionInputs.forEach(optionInput => {
        optionInput.addEventListener("change", this._onOptionChanged);
      });

      this.currentVariant = this._getVariantFromOptions(this.currentlySelectedOptions);
    }

    disconnectedCallback() {
      this.productForm.removeEventListener("change", this._onProductFormChanged);

      this.optionInputs.forEach(optionInput => {
        optionInput.removeEventListener("change", this._onOptionChanged);
      });
    }

    async _getProductJson() {
      const productHandle = this.getAttribute("product-handle");

      if (!productHandle) {
        return {};
      }

      const url = `${Shopify.routes.root}products/${productHandle}.js`;

      const response = await fetch(url).then(
        (data) => data.text()
      );

      return JSON.parse(response);
    }

    _onProductFormChange(event) {
      // TODO: Check which id is currently selected, update options selection, disable unavailable options
    }

    _onOptionChange(event) {
      this.currentVariant = this._getVariantFromOptions(this.currentlySelectedOptions);

      this._disableUnavailableOptions();

      this.productForm.dispatchEvent(new CustomEvent("variant:change", {
        bubbles: true,
        detail: {
          product: this.product,
          variant: this.currentVariant
        }
      }));
    }

    _disableUnavailableOptions() {
      // TODO
    }

    _getVariantById(variantId) {
      return this.product.variants.find(
        (variant) => variant.id === variantId
      );
    }

    _getVariantFromOptions(options) {
      return this.product.variants.find(
        (variant) => options.every((option, index) => {
          return variant.options[index] === option.value;
        })
      );
    }

    _serializeOptionValues(inputs) {
      return inputs.reduce(function(options, input) {
        if (input.checked || (input.type !== "radio" && input.type !== "checkbox")) {
          const regex = /(?:^(options\[))(.*?)(?:\])/;
          const optionName = regex.exec(input.name);

          if (optionName) {
            options.push({
              name: optionName[2],
              value: input.value
            });
          }
        }

        return options;
      }, []);
    }
  }

  customElements.define("variant-picker", VariantPicker);
}
